import { PublicClientApplication } from "@azure/msal-browser";

const MSAL_SCOPES = ["openid", "profile", "email", "User.Read"];

const msalConfig = {
  auth: {
    clientId: "5b6e9cb4-9de4-40e7-8222-d1b74e18e648",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: `${window.location.origin}/oidc/callback`
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false
  }
};

// Single instance so every part of the app (login, callback, silent refresh)
// reads/writes the same MSAL cache in localStorage instead of racing separate
// PublicClientApplication objects.
const msalInstance = new PublicClientApplication(msalConfig);

// Renews the Microsoft ID token in the background using MSAL's cached
// account, without a popup/redirect. Throws if MSAL has no cached account or
// can't renew silently (e.g. the underlying AAD session itself expired) —
// callers should treat that as "log the user out", not retry.
async function silentRefresh() {
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (!account) throw new Error("No cached Microsoft account for silent refresh");

  const result = await msalInstance.acquireTokenSilent({
    scopes: MSAL_SCOPES,
    account
  });
  msalInstance.setActiveAccount(result.account);
  return result.idToken;
}

export const msalService = {
  instance: msalInstance,
  scopes: MSAL_SCOPES,
  silentRefresh
};
